import { render, staticRenderFns } from "./DeliverForm.vue?vue&type=template&id=254d3171&scoped=true&"
import script from "./DeliverForm.vue?vue&type=script&lang=js&"
export * from "./DeliverForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliverForm.vue?vue&type=style&index=0&id=254d3171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d3171",
  null
  
)

export default component.exports